import { computed, ref } from 'vue'
import { useUser } from '@gat-ship/user'
import type { RecentVisitItem } from '@gat-ship/types'
import { dedupeRecentVisits } from '../model/bookmark-decisions'

export function useStakeholderRecentlyVisited() {
  const user = useUser()

  const isLoading = ref(false)

  const recentlyVisited = computed(() => {
    return user.userState.activeDb.state.value['stakeholders.recently-visited']
  })

  async function fetchRecentlyVisited() {
    isLoading.value = true
    try {
      const result = await user.userState.activeDb.getState(
        'stakeholders.recently-visited'
      )
      return result
    } finally {
      isLoading.value = false
    }
  }

  async function clearAllRecentlyVisitedItems() {
    await user.userState.activeDb.removeItem('stakeholders.recently-visited')
  }

  async function addToRecentlyVisitedItems(item: RecentVisitItem) {
    const MAX_RECENT_VISITS = 10

    const currentItem = {
      id: item.id,
      text: item.text,
      type: item.type,
      timestamp: Date.now()
    }
    const updatedRecentVisits = dedupeRecentVisits(
      await fetchRecentlyVisited(),
      currentItem,
      MAX_RECENT_VISITS
    )

    user.userState.activeDb.setItem(
      'stakeholders.recently-visited',
      updatedRecentVisits
    )
  }

  async function removeFromRecentlyVisitedItems(item: RecentVisitItem) {
    const currentRecentlyVisited = await fetchRecentlyVisited()
    const updatedRecentlyVisited = currentRecentlyVisited.filter(
      (i) => i.id !== item.id
    )
    await user.userState.activeDb.setItem(
      'stakeholders.recently-visited',
      updatedRecentlyVisited
    )
  }

  return {
    recentlyVisited,
    fetchRecentlyVisited,
    clearAllRecentlyVisitedItems,
    addToRecentlyVisitedItems,
    removeFromRecentlyVisitedItems
  }
}
